import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function SearchBox() {
    const [name, setName] = useState('');
    const navigate = useNavigate();

    const submitHandler = (e) => {
        e.preventDefault();
        navigate(`/search/name/${name}`);
    }
    return (
        <form className="search search-box" onSubmit={submitHandler}>
            <div className="row">
                <input type="text" name="q" id="q" onChange={(e) => setName(e.target.value)}>

                </input>
                <button className="primary" type="submit">
                    <i className="fa fa-search"></i>
                </button>
            </div>
        </form>
    )
}

export default SearchBox
